import { dsgvoLogging } from "../apis/apolyApi/apolyApi";
// this is the google-script rewritten in es7 js
import { logErrorGracefully } from "../failGracefully";

/* eslint-disable no-param-reassign */

const pTimeout = time => new Promise(resolve => setTimeout(resolve, time));

// Disable tracking if the opt-out cookie exists.
const disableStr = `ga-disable-${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`;
if (document.cookie.indexOf(`${disableStr}=true`) > -1) {
  window[disableStr] = true;
}

export const gaOptout = () => {
  document.cookie = `${disableStr}=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/`;
  window[disableStr] = true;
};

const loadAsyncHide = (
  win,
  documentElement,
  asyncHideClassName,
  dataLayerName,
  waitMs,
  gtmObj,
  fn,
) => {
  // eslint-disable-next-line prefer-template
  documentElement.className += " " + asyncHideClassName;
  gtmObj.start = 1 * new Date();
  // eslint-disable-next-line no-multi-assign
  gtmObj.end = fn = () => {
    documentElement.className = documentElement.className.replace(
      // eslint-disable-next-line prefer-template
      RegExp(" ?" + asyncHideClassName),
      "",
    );
  };
  (win[dataLayerName] = win[dataLayerName] || []).hide = gtmObj;
  setTimeout(() => {
    fn();
    gtmObj.end = null;
  }, waitMs);
  gtmObj.timeout = waitMs;
};

const andParamOrNothing = (name, value) => (value ? `&${name}=${value}` : "");

const googlesInitTagManagerScript = (
  win,
  doc,
  scriptTagName,
  dataLayerPropName,
  googleTagId,
) =>
  new Promise(resolve => {
    win[dataLayerPropName] = win[dataLayerPropName] || [];

    win[dataLayerPropName].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    const currentDomScriptTags = doc.getElementsByTagName(scriptTagName)[0];
    const googleTagManagerScript = doc.createElement(scriptTagName);
    const dataLayerParam =
      dataLayerPropName !== "dataLayer" ? `&l=${dataLayerPropName}` : "";

    const gtmAuthParam = andParamOrNothing(
      "gtm_auth",
      process.env.REACT_APP_GOOGLE_TAG_MANAGER_AUTH,
    );
    const gtmPreview = andParamOrNothing(
      "gtm_preview",
      process.env.REACT_APP_GOOGLE_TAG_MANAGER_PREVIEW,
    );
    const gtmCookies = andParamOrNothing(
      "gtm_cookies_win",
      process.env.REACT_APP_GOOGLE_TAG_MANAGER_COOKIES_WIN,
    );

    try {
      googleTagManagerScript.addEventListener("load", resolve);
    } catch (e) {
      logErrorGracefully(e);
      setTimeout(resolve, 5000);
    }

    googleTagManagerScript.async = true;
    googleTagManagerScript.src = `https://www.googletagmanager.com/gtm.js?id=${googleTagId}${dataLayerParam}${gtmAuthParam}${gtmPreview}${gtmCookies}`;
    currentDomScriptTags.parentNode.insertBefore(
      googleTagManagerScript,
      currentDomScriptTags,
    );
  });

const initTagManager = () =>
  Promise.resolve("fix")
    .then(() =>
      loadAsyncHide(
        window,
        document.documentElement,
        "async-hide",
        "dataLayer",
        4000,
        {
          "GTM-M3R4PN5": true,
        },
      ),
    )
    .then(() =>
      googlesInitTagManagerScript(
        window,
        document,
        "script",
        "dataLayer",
        process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
      ),
    )
    .then(() => pTimeout(5000))
    .then(() => dsgvoLogging("pageload"))
    .catch(logErrorGracefully);

export default initTagManager;
